import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { GameInfo } from '../../domain/signals/game-info';
import { BetStartService } from '../bet-start/bet-start.service';
import { DrawingService } from '../drawing/drawing.service';
import { SessionService } from '../session/session.service';
import { SystemConfig } from '../../config/system-config';

@Injectable()
export class InitialStateService {

    constructor(public http: Http,
        public betStartService: BetStartService,
        public drawingService: DrawingService,
        public sessionService: SessionService) {
    }

    public fetchInitialState() {
        let headers: Headers = new Headers();
        this.http.get(SystemConfig.Endpoint.INITIAL_STATE, {
            headers: headers
        }).subscribe((res: Response) => {
            let initialEvent: { SecondsSinceEvent: number, GameInfo: GameInfo, JackpotValue: number } = res.json();

            if (!initialEvent || initialEvent.GameInfo === null || initialEvent.SecondsSinceEvent > 600) {
                setTimeout(() => this.fetchInitialState(), 2000);
                return;
            }

            this.sessionService.jackpot = initialEvent.JackpotValue;

            switch (initialEvent.GameInfo.State) {
                case GameInfo.States.BET_START:
                    this.betStartService.initializeBetStart(initialEvent.GameInfo, initialEvent.SecondsSinceEvent);
                break;
                    case GameInfo.States.DRAWING:
                    this.drawingService.startDrawing(initialEvent.GameInfo, initialEvent.SecondsSinceEvent);
                break;
            }
        }, (e) => setTimeout(() => this.fetchInitialState(), 2000));
    }
}



// WEBPACK FOOTER //
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/src/app/shared/services/initial-state/initial-state.service.ts